var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$route.query.flag == 'view')?_c('span',[_c('BasicViewInfo',{ref:"getBasicView",on:{"childClick":_vm.childClick}},[_vm._v(">")])],1):_c('span',[_c('BasicUpdateInfo',{ref:"getBasicUpdate",on:{"childClick":_vm.childClick}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5324282e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/member/memberInfo/BasicInfo.vue
// module id = null
// module chunks = 